import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { navigateToOrderInfoBrowse } from "@web/app/pages/orders/order-info-navigation.util";
import { ReceiptsService } from "@services/dws/receipts.service";
import {
  AiAgentUiCommand,
  AiAgentUiCommandContext,
  AiAgentUiCommandHandler,
} from "../ai-agent-ui-command.types";

@Injectable({ providedIn: "root" })
export class OpenOrderHandler implements AiAgentUiCommandHandler {
  constructor(private router: Router, private receiptsService: ReceiptsService) {}

  supports(type: string): boolean {
    return type === "openOrder";
  }

  async handle(cmd: AiAgentUiCommand, _ctx?: AiAgentUiCommandContext): Promise<void> {
    if (cmd.orderId === undefined || cmd.orderId === null) {
      return;
    }
    await navigateToOrderInfoBrowse(this.router, this.receiptsService, {
      id: cmd.orderId,
    });
  }
}
